import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let compDeptOptions = [];
function UserDepartmentTableRow({ index, compDepartments, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [compDeptLoaded, setCompDeptLoaded] = useState(false);
	const [deptSelected, setDeptSelected] = useState({ name: "departmentKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setCompanyDepartmentValues(compDepartments);
	}, []);

	function setCompanyDepartmentValues(deptObj) {
		let compDeptValue = {};
		compDeptOptions = [];
		compDeptOptions.push({ label: "", value: 0 });
		if (deptObj && deptObj.length > 0) {
			deptObj.map((aDept, idx) => {
				compDeptValue.label = aDept.departmentName;
				compDeptValue.value = aDept.departmentKey;
				compDeptOptions.push(compDeptValue);
				compDeptValue = {};
			});
			setCompDeptLoaded(true);
		}
	}
	const deptHandler = (selectedOption, action) => {
		let departmentKey = selectedOption ? selectedOption.value : 0;
		let departmentName = selectedOption ? selectedOption.label : "";
		setDeptSelected({ ...deptSelected, label: (departmentName), value: departmentKey });
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			departmentKey: deptSelected.value
		};

		if (!deptSelected.value || deptSelected.value === 0) {
			setError(t("error.deptNameReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{compDeptLoaded ? <Select
					name="departmentKey"
					options={compDeptOptions}
					onChange={deptHandler}
					placeholder={""}
					value={deptSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="departmentKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(compDeptOptions && compDeptOptions.length >0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserDepartmentTableRow;